import { Button, Card, TextField, Typography } from '@mui/material'
import PublicPageWrapper from 'components/wrappers/PublicPageWrapper'
import Head from 'next/head'
import Image from 'next/image'
import styles from './contact.module.scss'
import customerSatisfactionImage from '../public/images/index/index-customer-satisfaction.png'
import Link from 'next/link'
import React from 'react'
import axios from 'axios'
import validator from 'validator'
import Immutable from 'immutable'
import FormError from 'components/page-content/FormError'
import FormFeedbackWrapper from 'components/page-content/FormFeedbackWrapper'

export default function Home() {

  const [fieldValues, setFieldValues] = React.useState(Immutable.fromJS({}));
  const [fieldErrors, setFieldErrors] = React.useState(Immutable.fromJS({}));
  const [formErrors, setFormErrors] = React.useState(Immutable.fromJS({}));
  const [fetching, setFetching] = React.useState(false);
  const [submitSuccess, setSubmitSuccess] = React.useState(false);


  const doValidation = (newValue, fieldKey) => {
    switch (fieldKey) {
      case 'email':
        if (validator.isEmpty(newValue)) {
          setFieldErrors(fieldErrors.set(fieldKey, 'Please enter your email address.'));
          return false;
        } else if (!validator.isEmail(newValue)) {
          setFieldErrors(fieldErrors.set(fieldKey, 'Please enter a valid email address.'));
          return false;
        } else {
          setFieldErrors(fieldErrors.delete(fieldKey));
          return true;
        }

      case 'message':
        if (validator.isEmpty(newValue)) {
          setFieldErrors(fieldErrors.set(fieldKey, 'Please enter your message.'));
          return false;
        } else {
          setFieldErrors(fieldErrors.delete(fieldKey));
          return true;
        }

      case 'name':
        if (validator.isEmpty(newValue)) {
          setFieldErrors(fieldErrors.set(fieldKey, 'Please enter your message.'));
          return false;
        } else {
          setFieldErrors(fieldErrors.delete(fieldKey));
          return true;
        }

      default:
        return true;
    }
  }

  const onValueChange = (newValue, fieldKey) => {
    setFieldValues(fieldValues.set(fieldKey, newValue));
    doValidation(newValue, fieldKey);
  }

  const checkRequiredFields = () => {
    const requiredFields = ['email', 'message', 'name'];
    let valid = true;
    requiredFields.forEach((field) => {
      if (valid) {
        valid = doValidation(fieldValues.get(field, ''), field);
      }
    })
    return valid;
  }

  const onSubmit = (event) => {
    if (!checkRequiredFields()) return;
    setFetching(true);
    try {
      axios.post(
        'https://formspree.io/f/maykbkkd',
        {
          email: fieldValues.get('email'),
          message: fieldValues.get('message'),
          name: fieldValues.get('name'),
        },
        {
          headers: {
            'Accept': 'application/json'
          }
        }
      )
      setSubmitSuccess(true);
    } catch (error) {
      setFormErrors(Immutable.fromJS({'generic_error': ['There was a problem with sending your message.']}));
    }
    setFetching(false);
  }

  return (
    <div>
      <Head>
        <title>MyTags | Contact us</title>
        <link rel="icon" href="/favicon.ico" />
        <script defer data-domain="mytags.info" src="https://plausible.io/js/plausible.js"></script>
      </Head>

      <PublicPageWrapper>

      <section className={`${styles.contactIntro} ${styles.container}`}>
          <Typography variant='h1' textTransform='uppercase' fontSize={64}>
            Contact us
          </Typography>
          <Typography variant='subtitle1' fontSize={18}>
            If you have any questions or suggestions, please feel free to reach out to us using the contact form below!
          </Typography>
        </section>

        <section className={`${styles.contactForm} ${styles.container}`}>

          {submitSuccess ? (
            <div className={styles.formFeedback}>
              <Typography variant='subtitle1' fontSize={18} marginBottom={0}>
                Your message was successfully sent. We'll respond to you shortly!
              </Typography>
            </div>
          ) : (
            <div className={styles.contactFormWrapper}>

              <FormError errorsList={formErrors} />
              <FormFeedbackWrapper doFeedback={fetching}>

                <TextField
                  value={fieldValues.get('email', '')}
                  onChange={(event) => onValueChange(event.target.value, 'email')}
                  helperText={fieldErrors.get('email') || ''}
                  error={fieldErrors.get('email') ? true : false}
                  label='Your email'
                  type='email'
                  variant='outlined'
                  required
                  fullWidth
                  sx={{ mb: 2 }}
                />

                <TextField
                  value={fieldValues.get('name', '')}
                  onChange={(event) => onValueChange(event.target.value, 'name')}
                  helperText={fieldErrors.get('name') || ''}
                  error={fieldErrors.get('name') ? true : false}
                  label='Your name'
                  type='text'
                  variant='outlined'
                  required
                  fullWidth
                  sx={{ mb: 2 }}
                />

                <TextField
                  value={fieldValues.get('message', '')}
                  onChange={(event) => onValueChange(event.target.value, 'message')}
                  helperText={fieldErrors.get('message') || ''}
                  error={fieldErrors.get('message') ? true : false}
                  label='Your message'
                  type='text'
                  variant='outlined'
                  required
                  fullWidth
                  sx={{ mb: 2 }}
                  multiline
                  minRows={6}
                />

                <Button
                  variant='contained'
                  size='large'
                  disableElevation
                  onClick={onSubmit}
                  disabled={fieldErrors.size ? true : false}
                >
                  Send message
                </Button>

              </FormFeedbackWrapper>

            </div>
          )}

        </section>

        <div className={styles.presentationStripe}>
          <section className={`${styles.ctaBoxStripe} ${styles.containerWide}`}>
            <Card>
              <div className={styles.ctaBoxStripeCard}>
                <div></div>
                <div className={`${styles.ctaBoxStripeContent} ${styles.container}`}>
                  <div>
                    <Typography variant='h2' color='common.white'>
                      Start elevating your rental business <u>now</u> and delight your visitors
                    </Typography>
                    <Typography variant='subtitle2' color='common.white'>
                      Answer all your Visitor's questions with just a few clicks. Sign up now for FREE - no credit card required.
                    </Typography>
                  </div>
                  <Link href='/create-account' passHref>
                    <Button
                      variant='contained'
                      color='primary'
                      fullWidth
                      disableElevation
                      size='large'
                    >
                      Sign up now
                    </Button>
                  </Link>
                </div>
                <div className={styles.ctaBoxGraphic}>
                  <Image
                    src={customerSatisfactionImage}
                    alt='Scan the QR code to see the Tag!'
                    layout='responsive'
                    sizes="(min-width: 75em) 33vw,
                        (min-width: 48em) 50vw,
                        100vw"
                  />
                </div>
              </div>
            </Card>
          </section>
        </div>

      </PublicPageWrapper>
    </div>
  )
}

export async function getStaticProps() {

  return {
    props: {},
    revalidate: 10,
  }
}
